import React, { forwardRef } from 'react';
import BaseButton, { BaseButtonProps } from './BaseButton';

interface IconButtonProps extends BaseButtonProps {
  icon?: string;
  'aria-label': string;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({
  icon,
  'aria-label': ariaLabel,
  variant = 'primary',
  className = '',
  ...props
}, ref) => {
  return (
    <BaseButton
      ref={ref}
      variant={variant}
      className={`button-icon-only ${className}`}
      aria-label={ariaLabel}
      {...props}
    >
      {icon && (
        <img 
          src={icon} 
          alt={ariaLabel}
          className="button-icon-image"
        />
      )}
    </BaseButton>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton; 